import { classNames } from '@op/opds.opux';
import { type HTMLAttributes, type ReactNode } from 'react';
import styles from './TileHeading.module.scss';

interface Props extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export const TileHeading = ({ children, className, ...rest }: Props) => (
  <div
    role='heading'
    aria-level={2}
    className={classNames(styles.heading, className)}
    {...rest}>
    {children}
  </div>
);
